import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from 'react-router-dom';

//Router
import {
    Route,
    Switch
} from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

//Controllers

import { headerSearch, tabs, unoTheme } from '../../../../assets/styles/unoTheme';

import PrintIcon from '@material-ui/icons/Print';
import CodeIcon from '@material-ui/icons/Code';
import { MyTab, MyTabs } from "../../../utils/MyTabs";
import UnoButton from '../../../utils/UnoButton';
import { distributionOptionClassification } from '../../../utils/distribution';
import { path } from "../../../utils/routesPaths";
import ReturnsTab from './tabs/ReturnsTab';
import { useRef } from 'react';
import GlobalTab from './tabs/GlobalTab';
import AssetsTab from './tabs/AssetsTab';
import SegregationTab from './tabs/SegregationTab';
import ClassesTab from './tabs/ClassesTab';
import { checkUserIsRole, roles } from '../../../utils/user';
import ArticlesTab from './tabs/ArticlesTab';
import BenchmarkTab from './tabs/BenchmarkTab';
import { getRegimeOptions, REGIME_LABELS } from '../../../utils/accountRegimes';
import MySelect from '../../../utils/MySelect';
import { loadClientRentsInconsistencies, loadClientSegmentRentsInconsistencies } from '../../../../controllers/ClientController';
import { SEGMENT_CODS_AND_LABELS } from '../../../../controllers/AssetsController';
import { Dialog, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Typography } from '@material-ui/core';
import moment from 'moment';
import { applyMaskAmountFreeDecimals, greenOrRed } from '../../../utils/utils';

const {
    benchmark_anbima,
} = distributionOptionClassification;

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    tabs: tabs,
    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },
    bottomTabs: {
        height: '24px',
        width: '100%',
        background: unoTheme.menuContent,
    },
    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: '16px',
        alignItems: 'center',
        justifyContent: 'space-between',

        '& .MuiToggleButtonGroup-root': {
            alignItems: 'center',

            '& .MuiToggleButton-label': {
                whiteSpace: 'nowrap'
            }
        }
    },

    flexCenterDiv: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    rightHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: "8px",
        '& .ipc14-components': {
            display: 'flex',
            alignItems: 'center',
            gap: "12px",
        }
    },

});

export default function ReturnsScreen() {

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser)
    const [tabValue, setTabValue] = useState(null);

    const [clientOnScreen, setClientOnScreen] = useState(undefined);

    const [month, setMonth] = useState(undefined);
    const [year, setYear] = useState(undefined);

    const dailyReturnsTabRef = useRef();
    const globalReturnsTabRef = useRef();
    const assetsReturnsTabRef = useRef();
    const segregationReturnsTabRef = useRef();
    const articlesReturnsTabRef = useRef();
    const benchmarkReturnsTabRef = useRef();
    const classesReturnsTabRef = useRef();

    const [segregationSelected, setSegregationSelected] = useState(0);
    const [segmentSelected, setSegmentSelected] = useState(Object.keys(SEGMENT_CODS_AND_LABELS)[0]);

    const segmentsOptions = useMemo(() => {
        return Object.entries(SEGMENT_CODS_AND_LABELS).map(([key, label]) => ({ value: key, name: label }));
    }, []);

    const INCONSISTENCY_THRESHOLD = 5;

    const [inconsistencies, setInconsistencies] = useState([]);
    const [inconsistencyModalOpen, setInconsistencyModalOpen] = useState(false);
    const [inconsistencyLoading, setInconsistencyLoading] = useState(false);

    const [segmentInconsistencies, setSegmentInconsistencies] = useState([]);
    const [segmentInconsistencyModalOpen, setSegmentInconsistencyModalOpen] = useState(false);
    const [segmentInconsistencyLoading, setSegmentInconsistencyLoading] = useState(false);

    async function doCheckInconsistencies() {
        if (!clientOn || !clientOn.client || !clientOn.client.id) return;
        setInconsistencyLoading(true);
        setInconsistencyModalOpen(true);
        const response = await loadClientRentsInconsistencies(clientOn.client.id, INCONSISTENCY_THRESHOLD);
        setInconsistencies(response.isSuccessful ? response.inconsistencies : []);
        setInconsistencyLoading(false);
    }

    async function doCheckSegmentInconsistencies() {
        if (!clientOn || !clientOn.client || !clientOn.client.id) return;
        setSegmentInconsistencyLoading(true);
        setSegmentInconsistencyModalOpen(true);
        const response = await loadClientSegmentRentsInconsistencies(clientOn.client.id, INCONSISTENCY_THRESHOLD);
        setSegmentInconsistencies(response.isSuccessful ? response.inconsistencies : []);
        setSegmentInconsistencyLoading(false);
    }

    const segregationsOptions = useMemo(
        () => getRegimeOptions(clientOn, { includeConsolidated: true }),
        [clientOn]);

    //Abas cujo resultado é recortado pela segregação. Ficam de fora: Segregação (3), que já lista
    //todos os regimes; Benchmark (5), que são índices de mercado; e Classe (6), cujas cotas ainda
    //não são calculadas por regime
    const TABS_WITH_SEGREGATION_FILTER = [0, 1, 2, 4];
    const showSegregationFilter = !!clientOn?.client?.is_cotization_segregation
        && TABS_WITH_SEGREGATION_FILTER.includes(tabValue);

    const handleChangeTabValue = (event, newValue) => {

        setTabValue(newValue);

        if (newValue == 0) {
            history.push(path.analysis.returns.daily)
        } else if (newValue == 1) {
            history.push(path.analysis.returns.global)
        } else if (newValue == 2) {
            history.push(path.analysis.returns.assets)
        } else if (newValue == 3) {
            history.push(path.analysis.returns.segregation)
        } else if (newValue == 4) {
            history.push(path.analysis.returns.articles)
        } else if (newValue == 5) {
            history.push(path.analysis.returns.benchmark)
        } else if (newValue == 6) {
            history.push(path.analysis.returns.classes)
        }

    };

    const getRefByTabValue = (tabValue) => {
        let theRef = null;
        switch (tabValue) {
            case 0:
                theRef = dailyReturnsTabRef;
                break;
            case 1:
                theRef = globalReturnsTabRef;
                break;
            case 2:
                theRef = assetsReturnsTabRef;
                break;
            case 3:
                theRef = segregationReturnsTabRef;
                break;
            case 4:
                theRef = articlesReturnsTabRef;
                break;
            case 5:
                theRef = benchmarkReturnsTabRef;
                break;
            case 6:
                theRef = classesReturnsTabRef;
                break;
            default:
                break;
        }

        return theRef;
    }

    const doExcelRef = (tabValue) => {

        const theRef = getRefByTabValue(tabValue);

        if (theRef?.current) theRef.current.doExcelReport();
    }

    const doPdfRef = (tabValue) => {
        const theRef = getRefByTabValue(tabValue);
        if (theRef?.current) theRef.current.doPdfReport();
    }

    useEffect(() => {

        if (!clientOn?.client) return;

        // Só volta para a primeira aba quando o CLIENTE muda,
        // não quando apenas o mês/ano do dashboard é alterado.
        if (clientOnScreen !== clientOn.client.id) {
            handleChangeTabValue(null, 0)
            setClientOnScreen(clientOn.client.id)
            //O regime escolhido para o cliente anterior pode não estar habilitado para o novo
            setSegregationSelected(0)
        }

        const { selectedPortfolioMonth, selectedPortfolioYear } = clientOn.client;

        setMonth(selectedPortfolioMonth)
        setYear(selectedPortfolioYear)

    }, [clientOn]);

    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>

                <div className={[classes.tabs, classes.shortWidthTab].join(' ')} style={{ width: "auto" }}>

                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}>

                        <MyTab label="Diários" value={0} />
                        <MyTab label="Globais" value={1} />
                        <MyTab label="Ativo" value={2} />
                        {
                            clientOn?.client?.is_cotization_segregation &&
                            <MyTab label="Segregação" value={3} />
                        }
                        {/* {
                            checkUserIsRole(currentUser, [roles.superadmin]) &&
                        } */}
                        <MyTab label="Enquadramento" value={4} />
                        <MyTab label="Benchmark" value={5} />
                        {
                            clientOn?.client?.is_cotization_segregation &&
                            <MyTab label="Classe" value={6} />
                        }


                    </MyTabs>

                </div>


                {
                    (tabValue === 0
                        || tabValue === 1
                        || tabValue === 2
                        || tabValue === 3
                        || tabValue === 4
                        || tabValue === 5
                        || tabValue === 6) &&
                    <div className={classes.rightHeader}>

                        {
                            showSegregationFilter &&
                            <MySelect
                                customWidth={'200px'}
                                value={segregationSelected}
                                onChange={(e) => setSegregationSelected(e.target.value)}
                                options={segregationsOptions.map((row, index) => (
                                    <option key={'segregation-selected-returns-' + index} value={row.value}>{row.name}</option>
                                ))}
                            />
                        }
                        {
                            tabValue === 0 &&
                            <div style={{ display: 'flex', alignItems: 'center', gap: "8px" }}>
                                <UnoButton
                                    isIconButton
                                    size={'small'}
                                    onClick={() => doExcelRef(tabValue)}
                                    type='success'
                                    startIcon={<PrintIcon />}>
                                </UnoButton>

                                {
                                    checkUserIsRole(currentUser, [roles.superadmin, roles.admin]) &&
                                    <UnoButton
                                        className={classes.spacingLeft1}
                                        isIconButton
                                        size='small'
                                        type='warning'
                                        myIcon={<CodeIcon />}
                                        onClick={() => doCheckInconsistencies()}
                                    />
                                }
                            </div>
                        }
                        {
                            tabValue === 6 && clientOn?.client?.is_cotization_segregation &&
                            <div style={{ display: 'flex', alignItems: 'center', gap: "8px" }}>
                                <MySelect
                                    customWidth={'200px'}
                                    value={segmentSelected}
                                    onChange={(e) => setSegmentSelected(e.target.value)}
                                    options={segmentsOptions.map((row, index) => (
                                        <option key={'segment-selected-returns-' + index} value={row.value}>{row.name}</option>
                                    ))}
                                />
                                {/* <UnoButton
                                    isIconButton
                                    size={'small'}
                                    onClick={() => doExcelRef(tabValue)}
                                    type='success'
                                    startIcon={<PrintIcon />}>
                                </UnoButton>
                                */}
                                {
                                    checkUserIsRole(currentUser, [roles.superadmin, roles.admin]) &&
                                    <UnoButton
                                        isIconButton
                                        size='small'
                                        type='warning'
                                        myIcon={<CodeIcon />}
                                        onClick={() => doCheckSegmentInconsistencies()}
                                    />
                                }
                            </div>
                        }
                        {
                            tabValue !== 6 ?
                                <UnoButton
                                    size={'small'}
                                    onClick={() => doPdfRef(tabValue)}
                                    type='primary'
                                    isIconButton
                                    startIcon={<PrintIcon />}>
                                </UnoButton> : null
                        }

                    </div>
                }


            </div>
            <Switch className={classes.switch}>
                <Route path={path.analysis.returns.daily}>
                    <ReturnsTab ref={dailyReturnsTabRef} segregationSelected={segregationSelected} />
                </Route>
                <Route path={path.analysis.returns.global}>
                    <GlobalTab ref={globalReturnsTabRef} segregationSelected={segregationSelected} />
                </Route>
                <Route path={path.analysis.returns.assets}>
                    <AssetsTab ref={assetsReturnsTabRef} segregationSelected={segregationSelected} />
                </Route>
                <Route path={path.analysis.returns.segregation}>
                    <SegregationTab ref={segregationReturnsTabRef} />
                </Route>
                <Route path={path.analysis.returns.articles}>
                    <ArticlesTab ref={articlesReturnsTabRef} segregationSelected={segregationSelected} />
                </Route>
                <Route path={path.analysis.returns.benchmark}>
                    <BenchmarkTab ref={benchmarkReturnsTabRef} />
                </Route>
                <Route path={path.analysis.returns.classes}>
                    <ClassesTab ref={classesReturnsTabRef} segmentSelected={segmentSelected} />
                </Route>



            </Switch>

            <Dialog
                open={inconsistencyModalOpen}
                onClose={() => setInconsistencyModalOpen(false)}
                maxWidth="md"
                fullWidth>
                <DialogTitle>
                    {"Inconsistências — rent_day fora do intervalo [−5%, +5%]"}
                </DialogTitle>
                <DialogContent>
                    {inconsistencyLoading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '32px' }}>
                            <CircularProgress />
                        </div>
                    ) : inconsistencies.length === 0 ? (
                        <Typography style={{ padding: '16px 0' }}>
                            Nenhuma inconsistência encontrada.
                        </Typography>
                    ) : (
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Data</TableCell>
                                    <TableCell>Segregação</TableCell>
                                    <TableCell align="right">Rent Day (%)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {inconsistencies.slice().sort(function (a, b) { return Math.abs(parseFloat(b.rent_day)) - Math.abs(parseFloat(a.rent_day)); }).map((row, index) => (
                                    <TableRow key={'incons-' + index}>
                                        <TableCell>{moment.utc(row.date_quota).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell>{REGIME_LABELS[row.segregation_cod] || row.segregation_cod}</TableCell>
                                        <TableCell align="right" style={{ color: greenOrRed(row.rent_day) }}>
                                            {applyMaskAmountFreeDecimals(row.rent_day)}%
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </DialogContent>
            </Dialog>

            <Dialog
                open={segmentInconsistencyModalOpen}
                onClose={() => setSegmentInconsistencyModalOpen(false)}
                maxWidth="md"
                fullWidth>
                <DialogTitle>
                    {"Inconsistências por Classe — rent_day fora do intervalo [−5%, +5%]"}
                </DialogTitle>
                <DialogContent>
                    {segmentInconsistencyLoading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '32px' }}>
                            <CircularProgress />
                        </div>
                    ) : segmentInconsistencies.length === 0 ? (
                        <Typography style={{ padding: '16px 0' }}>
                            Nenhuma inconsistência encontrada.
                        </Typography>
                    ) : (
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Data</TableCell>
                                    <TableCell>Classe</TableCell>
                                    <TableCell align="right">Rent Day (%)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {segmentInconsistencies.slice().sort(function (a, b) { return Math.abs(parseFloat(b.rent_day)) - Math.abs(parseFloat(a.rent_day)); }).map((row, index) => (
                                    <TableRow key={'seg-incons-' + index}>
                                        <TableCell>{moment.utc(row.date_quota).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell>{SEGMENT_CODS_AND_LABELS[row.segment_cod] || row.segment_cod}</TableCell>
                                        <TableCell align="right" style={{ color: greenOrRed(row.rent_day) }}>
                                            {applyMaskAmountFreeDecimals(row.rent_day)}%
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </DialogContent>
            </Dialog>

        </div>

    )
}




